import { Modal } from "reactstrap";
import styles from "./index.module.scss";
import SocialMapLogo from "./images/socialmap-logo.png";
import { Link } from "react-router-dom";

const ConfirmationModal = (props) => {
  const { open, setOpen, onConfirm, onRegisterCso } = props;
  return (
    <>
      <Modal
        isOpen={open}
        backdrop={true}
        toggle={setOpen}
        backdropClassName={styles["reverted-backdrop"]}
        className={styles["supporter-registration-modal"]}
      >
        <div
          style={{
            padding: "100px 100px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "2rem",
            }}
          >
            <img src={SocialMapLogo} alt="SocialMap Logo" />
            <div
              style={{
                fontSize: "20px",
                marginLeft: "12px",
              }}
            >
              組織としてアカウント利用
            </div>
          </div>
          <p>
            「組織としてアカウント利用」は、「CSO」と「サポーター」二つの組織の種類があります。組織としてSocial
            mapを利用することで、自組織の理解・成長[1.オーガニゼーション機能]と他の組織との効果的な連携[2.パートナーシップ機能]を実現できます。
          </p>
          <div
            style={{
              marginTop: "2rem",
            }}
          >
            <button
              type="button"
              style={{
                display: "inline-block",
                padding: "15px 17px",
                backgroundColor: "#44CAE1",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                marginBottom: "1rem",
                marginRight: "12px",
              }}
              onClick={onRegisterCso}
            >
              CSO登録
            </button>
            <a
              target="_blank"
              rel="noreferrer noopener"
              style={{
                display: "inline-block",
                padding: "15px 17px",
                backgroundColor: "#44CAE1",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                marginBottom: "1rem",
              }}
              href="https://docs.google.com/forms/d/e/1FAIpQLSc5-FN0c5lSklV-p6Ckniipz2578pvMb4chb2YNhrtsZLwqjA/viewform"
            >
              管理者登録
            </a>
            <p style={{ marginBottom: "2rem" }}>
              *NPO法人等、現場で活動を実施する、非営利組織が主な対象です。
            </p>
            <div
              style={{
                marginTop: "15px",
              }}
            >
              <button
                style={{
                  padding: "15px 17px",
                  backgroundColor: "#44CAE1",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                }}
                onClick={onConfirm}
              >
                サポーター登録へ
              </button>
            </div>
            <div
              style={{
                marginTop: "15px",
                marginBottom: "2rem",
              }}
            >
              <p>
                *株式会社（部署単位も可）などの営利組織や、助成金事業を行う一般・公益法人など、非営利組織をサポートする組織が主な対象です。
              </p>
            </div>
            <div>
              既に組織としてアカウント登録済みの方は、「
              <span>
                <Link to="/pages/login">ログイン</Link>
              </span>
              」してご使用ください。
              <br />
              組織（CSO・サポーター）として登録することで、できることを知りたい方は、
              <span>
                <Link
                  to="/dashboards/faq"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  FAQ
                </Link>
              </span>
              をご覧ください。
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
